var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Daftar"},[_c('v-card',{staticClass:"mx-auto mt-9",attrs:{"width":"500"}},[_c('v-card-title',[_vm._v("Daftar HID")]),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"HID","prepend-icon":"mdi-biohazard"}})],1),_c('v-divider'),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"success"}},[_vm._v("Daftar")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }